import { InlineFormInput, Spinner } from '@platform/components';
import { FormState, UseFormRegister } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type NameCustomProjectContentProps = {
  isSaving: boolean;
  register: UseFormRegister<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

export const NameCustomProjectContent = (props: NameCustomProjectContentProps) => {
  return (
    <div className='flex flex-col gap-4 items-center mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>
            What should we call this project? You can choose any name that you think describes the
            work you'll be doing.
          </div>
          <div className='mt-4 w-full'>
            <InlineFormInput
              placeholder='Grant proposal creation'
              register={() =>
                props.register('projectName', { required: 'Enter a project name to continue' })
              }
              errors={props.formState.errors.projectName}
              label='Project name'
              hideLabel
            />
          </div>
        </>
      }
    </div>
  );
};
